import { SVGProps, Ref, forwardRef } from 'react';

export const LabelUserFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .667C2.5.667.667 4.333.667 8S2.5 15.333 8 15.333 15.333 11.667 15.333 8 13.5.667 8 .667m0 2.91c-1.708 0-2.278 1.138-2.278 2.277S6.292 8.132 8 8.132s2.278-1.139 2.278-2.278S9.708 3.577 8 3.577M8 8.96c1.666 0 3.332.744 3.667 2.899H4.333C4.668 9.705 6.334 8.96 8 8.96"
                fill="currentColor"
            />
        </g>
    </svg>
));
LabelUserFilledSize16Glyph.displayName = 'LabelUserFilledSize16Glyph';
